import React, { useEffect, useState } from "react";
import {notifyError,exportLeadsToCSV, notifySuccess} from '../../helper';
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from '../../api';
import LeadRow from "./LeadRow";
import BlockLoader from "../BlockLoader";

const CampaignLeads = () => {
    const api = client();
    const [payload, setPayload] = useState({ searchText:"", campaignID:"", assignedTo:"", status:"open"});
    const [updatePayload, setUpdatePayload] = useState({leadID:[],assignedToEmail:"",status:""});
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [actionsDisplay,setActionsDisplay] = useState(false);
    const [blockLoader,setBlockLoader] = useState(true);
    const [count, setCount] = useState(0);
    const [allLeads, setAllLeads] = useState([]);
    const [campaignNames,setCampaignNames] = useState([]);
    const [users,setUsers] = useState([]);
    const [offset, setOffset] = useState(0); // For pagination
    const [limit] = useState(20); // Number of leads per request
    const [totalCount, setTotalCount] = useState(0); // Total leads available

    const addCheckedStatus = (data) => {
        const updatedData = data.map((v,i)=>({...v,isChecked:false}));
        setAllLeads(updatedData);
    }

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setIsAllChecked(isChecked);
        const updatedItems = allLeads.map((v,i)=>({...v,isChecked:isChecked}));
        setAllLeads(updatedItems);
        setActionsDisplay(isChecked);
        setCount(updatedItems.filter(item => item.isChecked).length);
    }

    const handleCheckboxChange = (id) => {
        const updatedItems = allLeads.map(item =>
            item._id === id ? { ...item, isChecked: !item.isChecked } : item
          );
          setIsAllChecked(updatedItems.every(item => item.isChecked));
          setActionsDisplay(updatedItems.some(item => item.isChecked));
          setAllLeads(updatedItems);
          setCount(updatedItems.filter(item => item.isChecked).length);
    }

    const handleFilter = (event) => {
        setPayload({...payload,[event.target.name]:event.target.value});
        setActionsDisplay(false);
        setIsAllChecked(false);
        setCount(0);
        setOffset(0); // Reset offset on filter change
    }

    const handleDownloadCSV = () => {
        exportLeadsToCSV(allLeads.filter(item => item.isChecked));
    }

    const updateLeadsStatus = async (updatePayload) => {
        //console.log('updatePayload',updatePayload);
        setUpdatePayload({...updatePayload});
        try{
            //console.log('updatePayload',updatePayload);
            const response = await api.post('/v1/lead/update',updatePayload);
            if(response.status === 200 || response.status === 201){
                notifySuccess('Lead status updated successfully');
                setTimeout(()=>{
                    window.location.reload();
                },1500);
            }
        } catch (error){
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to update Leads status');
        }
    }

    const handleLeadStatus = (e) => {
        setBlockLoader(true);
        const selectedItemIds = allLeads.filter(item => item.isChecked).map(item => item._id);
        if(e.target.name === 'status'){

        }
        if(e.target.value !== ""){
            //setUpdatePayload();
            updateLeadsStatus({...updatePayload,leadID:[...selectedItemIds],[e.target.name]:e.target.value});
        } else{
            setUpdatePayload({...updatePayload,leadID:[...selectedItemIds],[e.target.name]:e.target.value});
        }
        
    }

    const handleReopenLeads = (e) => {
        const selectedItemIds = allLeads.filter(item => item.isChecked).map(item => item._id);
        //setUpdatePayload();
        updateLeadsStatus({...updatePayload,leadID:[...selectedItemIds],status:"open"});
        
    }

    const getAllLeads = async (append = false) => {
        setBlockLoader(true);
        try {
            const response = await api.post("/v1/lead/get", { ...payload, offset, limit });
            if (response.status === 200 || response.status === 201) {
                const data = response.data.leads;
                setTotalCount(response.data.total_count); // Update total leads count
                addCheckedStatus(append ? [...allLeads, ...data] : data); // Append data if needed
                setBlockLoader(false);
            }
        } catch (error) {
            if (error.status === 400) notifyError("Bad Request. Unable to fetch lead data. Please try again.");
            setBlockLoader(false);
        }
    };

    const handleLoadMore = () => {
        setBlockLoader(true);
        setOffset((prevOffset) => prevOffset + limit);
    };

    useEffect(() => {
        getAllLeads(offset > 0); // Append data only if offset > 0
    }, [payload, offset]);

    useEffect(() => {
        const getAllCampaignNames = async () => {
            try{
                const response = await api.post('/v1/campaign/names/list');
                if(response.status === 200 || response.status === 201){
                    const data = response.data.campaignNames;
                    setCampaignNames(data);
                }
            } catch (error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch Campaigns. Please try again.');
            }
        }
        getAllCampaignNames();
    },[]);

    useEffect(()=>{
        const getAllUsers = async () => {
            try{
                const response = await api.get('/v1/user/list');
                if(response.status === 200 || response.status === 201){
                    setUsers(response.data.users_list);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch mail accounts. Please try again');
            }
        }
        getAllUsers();
    },[]);

 return(<>
    <Header/>
    <div className="main-page">
        <Sidebar/>
        <div className="campaign-pages-wrap">
            
            {actionsDisplay ? <div className="action-wrap lead-action-wrap">
                    <div className="selected-records">
                        {count} selected
                    </div>
                    <div className="action-group">
                        {payload.status === "open" ? (<><div className="field-wrap">
                            <select className="selectbox" name="status" value={updatePayload.status} onChange={handleLeadStatus}>
                                <option value="">Status</option>
                                <option value="ignore">Ignored</option>
                                <option value="won">Won</option>
                                <option value="lost">Lost</option>
                            </select>
                        </div>
                        <div className="field-wrap">
                            <select className="selectbox" name="assignedToEmail" value={updatePayload.assignedToEmail} onChange={handleLeadStatus}>
                                <option value="">Assign</option>
                                <option value="unassigned">Unassigned</option>
                                {users.map((user,j)=>(<option key={j} value={user.email}>{user.name}</option>))}
                            </select>
                        </div></>):(<button 
                            className="delete-btn"
                            name="status" 
                            onClick={handleReopenLeads}>Reopen</button>)}
                        <div className="field-wrap">
                        {/* <label className="label-xs">&nbsp;</label> */}
                        <button 
                            className="export-btn" 
                            onClick={handleDownloadCSV}>Export</button>
                        </div>
                    </div>
                </div>:<div className="top-section"><h1>Leads</h1></div>}
            <div className="leads-wrap">
                <div className="leads">
                    <div className="lead-data-block">
                        <div className="lead-filter">
                            <div className="field-wrap">
                                <input 
                                    type="text"
                                    name="searchText" 
                                    placeholder="Search" 
                                    value={payload.searchText}
                                    onChange={handleFilter} />
                            </div>
                            <div className="field-wrap">
                                <select 
                                    className="selectbox" 
                                    name="campaignID"
                                    value={payload.campaignID} 
                                    onChange={handleFilter}>
                                    <option value="">All Campaigns</option>
                                    {campaignNames && campaignNames.map((campaign,i)=>(<option key={i} value={campaign._id}>{campaign.name}</option>))}
                                </select>
                            </div>
                            <div className="field-wrap">
                                <select 
                                    className="selectbox"
                                    name="assignedTo"
                                    value={payload.assignedTo}
                                    onChange={handleFilter}
                                    >
                                    <option value="">All</option>
                                    <option value="unassigned">Unassigned</option>
                                    {users.map((user,j)=>(<option key={j} value={user._id}>{user.name}</option>))}
                                </select>
                            </div>
                            <div className="field-wrap">
                                <select 
                                    className="selectbox"
                                    name="status"
                                    value={payload.status}
                                    onChange={handleFilter}
                                >
                                    <option value="open">Open</option>
                                    <option value="won">Won</option>
                                    <option value="ignore">Ignored</option>
                                    <option value="lost">Lost</option>
                                </select>
                            </div>
                        </div>

                        {blockLoader ? <div className="block-loader" style={{minHeight:'550px', width:'100%',background:'#fff'}}><BlockLoader /></div> : <table>
                            <thead>
                                <tr>
                                    <th>
                                        <input 
                                            type="checkbox" 
                                            disabled={!Object.keys(allLeads).length}
                                            checked={Object.keys(allLeads).length && isAllChecked} 
                                            name="select-all" 
                                            onChange={handleSelectAll} />
                                    </th>
                                    <th>Email</th>
                                    <th>Campaign</th>
                                    <th>Assigned to</th>
                                    <th>Lead Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(allLeads).length ? allLeads.map((lead,k)=>(<LeadRow lead={lead} handleCheckboxChange = {handleCheckboxChange} key={k}/>)):<tr>
                                    <td colSpan={5}>Data not available</td>
                                    </tr>}
                            </tbody>
                        </table>}
                        <div className="more-records">
                                    {allLeads.length < totalCount && (
                                        <button onClick={handleLoadMore}>
                                            <i className="bx bx-chevron-down"></i>
                                        </button>
                                    )}
                                </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer/>
</>);
}

export default CampaignLeads;
